import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';
import { AppStore } from '../stores/app.store';

@Injectable()
export class AssetsService {

  constructor(private store: AppStore) {

  }

  base() {
    const base = `${environment.s3.host}${environment.s3.bucket}${environment.s3.path}`;
    return base;
  }

  logo() {
    let url;
    const file = `logo.png`;
    if (!this.store.companyId || !this.store.appId) {
      return url = 'assets/logo.png';
    }
    // return url = `${this.base()}${this.store.eventId}/assets/${file}`;
    return url = `${this.base()}assets/${this.store.companyId}/applications/${this.store.appId}/${file}`;
  }

  slogan() {
    let url;
    const file = `slogan.png`;
    if (!this.store.eventId) {
      return url = 'assets/slogan.png';
    }
    // return url = `${this.base()}${this.store.eventId}/assets/${file}`;
    return url = `${this.base()}assets/${this.store.companyId}/applications/${this.store.appId}/${file}`;
  }

  qrCode() {
    let url;
    const file = `qr.png`;
    if (!this.store.eventId) {
      return url = 'assets/qr-code.png';
    }
    // return url = `${this.base()}${this.store.eventId}/assets/${file}`;
    url = `${this.base()}assets/${this.store.companyId}/applications/${this.store.appId}/${file}`;
    return url
  }

  localCss() {
    const file = `custom.css`;
    // const url = 'assets/branding.css';
    // const url = `${this.base()}${this.store.eventId}/assets/${file}`;
    // const url = `https://s3-us-west-2.amazonaws.com/files.highattendance.com/dev/css/${this.store.companyId}/applications/${this.store.appId}/${file}`;
    const url = `${this.base()}css/${this.store.companyId}/applications/${this.store.appId}/${file}`;

    return url;
  }
}
